(function () {
  const productSlider = () => {
    $(document).ready(function () {
      $(".js-get-recently-viewed-section").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;
        
        let carousel = document
        .querySelector(parentId)
        .querySelector(`.js-swiper-recently-viewed-carousel`);
        
        let slidesPerViewDesktop = parseFloat($(parent).attr("data-products-per-row"));
        
        const slideCount = carousel.querySelectorAll(".swiper-slide").length;

        let swiperCarousel = new Swiper(carousel, {
          slidesPerView: 1.65,
          spaceBetween: 16,
          slidesOffsetAfter: 20,
          breakpoints: {
            768: { slidesPerView: 1.8, spaceBetween: 16 },
            990: { slidesPerView: slidesPerViewDesktop + .2, spaceBetween: 24 },
          },
        });
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        productSlider();
    }, 2000);
    document.addEventListener("shopify:section:load", function () {
        setTimeout(() => {
            productSlider();
        }, 2000);
    });
  });
})();
